import { Helmet } from "react-helmet-async";

const SITE_URL = "https://playmahjong.in";
const DEFAULT_IMAGE = `${SITE_URL}/og-default.jpg`;
const SITE_NAME = "PlayMahjong.in";

export function absoluteUrl(pathOrUrl = "") {
  if (!pathOrUrl) return SITE_URL;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const path = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return `${SITE_URL}${path}`;
}

const SEO = ({
  title,
  description,
  image = DEFAULT_IMAGE,
  path = "",
  noindex = false,
  jsonLd = null,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} - Find Local Mahjong Games`;
  const url = absoluteUrl(path);
  const imageUrl = image ? absoluteUrl(image) : DEFAULT_IMAGE;
  // Never emit an empty description — that would wipe the index.html fallback
  // and leave crawlers/share sheets with a blank snippet.
  const desc =
    (description && String(description).trim()) ||
    "Find and join local Mahjong games in your area. Sign up for events and get matched with players at your skill level.";
  const jsonLdList = jsonLd == null ? [] : Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : [jsonLd];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      {!noindex && <link rel="canonical" href={url} />}
      {!noindex && <link rel="describedby" href={`${SITE_URL}/llms.txt`} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={imageUrl} />

      {jsonLdList.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block).replace(/</g, "\\u003c")}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
